import { PageLocatorMap } from '../types/PageLocatorMap';

export const signUpReturningUserPage = {
  footer: {
    root: 'sign-up-returning-user.footer',
  },
  form: {
    backButton: 'sign-up-returning-user.form.back-button',
    emailInput: 'sign-up-returning-user.form.email-input',
    h1: 'sign-up-returning-user.form.heading1',
    h2: 'sign-up-returning-user.form.heading2',
    phoneInput: 'sign-up-returning-user.form.phone-input',
    root: 'sign-up-returning-user.form.root',
    signInButton: 'sign-up-returning-user.form.sign-in-button',
  },
  header: {
    root: 'sign-up-returning-user.header',
    signInLink: 'sign-up-returning-user.header.sign-in-link',
  },
} as const satisfies PageLocatorMap;
